var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ApexChartComponent',{attrs:{"chartType":_vm.chartTypeGiven,"chartOptions":_vm.chartOptionsGiven,"series":_vm.chartSeries}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }